export default __webpack_public_path__ + "static/media/cactus-login-logo.d7cb91c4.jpeg";